module.exports = __webpack_public_path__ + "img/ok.b48a8a90.png";